import { UseFormReturn } from "react-hook-form";
import { RouteRequestFormData } from "./TripFormTypeConversions";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DELETE_CONFIRMATION_NO, DELETE, SET_DAY_ONE_START_TIME } from "../../UserVisibleStrings";
import React, { useState } from "react";
import { updateWaypoint, useRiskViewerState, WaypointExpanded } from "../../../features/riskViewer/riskViewerSlice";
import { useDispatch } from "react-redux";
import { TimePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";

type DayOneStartDialogProps = {
    open: boolean,
    handleClose: () => void,
    formParent: UseFormReturn<RouteRequestFormData>,
    index: number,
};

export function DayOneStartDialog( {
    open,
    handleClose,
    formParent,
    index,
}: DayOneStartDialogProps )
{
    let defaultDate = new Date();
    if ( formParent.getValues( `waypoints.${index}.startTime` ) !== undefined )
    {
        defaultDate.setMinutes( formParent.getValues( `waypoints.${index}.startTime.minute` ) );
        defaultDate.setHours( formParent.getValues( `waypoints.${index}.startTime.hour` ) );
    }
    else
    {
        defaultDate = formParent.getValues( "dailyStartTime" );
    }

    const stateWaypoints = useRiskViewerState().waypoints;
    const dispatch = useDispatch();
    const [ value, setValue ] = useState( defaultDate );

    const saveAndClose = () =>
    {
        formParent.setValue( `waypoints.${index}.startTime.hour`, value.getHours() );
        formParent.setValue( `waypoints.${index}.startTime.minute`, value.getMinutes() );
        updateWaypointState( );
        handleClose();
    };

    const deleteStartTime = () =>
    {
        formParent.setValue( `waypoints.${index}.startTime`, undefined );

        if ( stateWaypoints !== undefined && stateWaypoints.length > index )
        {
            const updatedWaypoint: WaypointExpanded = {
                ...stateWaypoints[index],
                startTime: undefined,
            };

            dispatch( updateWaypoint( {
                index,
                waypoint: updatedWaypoint,
                isDrag: false,
            } ) );
        }

        handleClose();
    };

    const updateWaypointState = ( ) =>
    {
        if ( stateWaypoints !== undefined && stateWaypoints.length > index )
        {
            const updatedWaypoint: WaypointExpanded = {
                ...stateWaypoints[index],
                startTime: {
                    hour: value.getHours(),
                    minute: value.getMinutes(),
                }
            };

            dispatch( updateWaypoint( {
                index,
                waypoint: updatedWaypoint,
                isDrag: false
            } ) );
        }
    };

    return (
        <Dialog open = {open} onClose = {handleClose} PaperProps = {{ style: { width: "350px" } }}>
            <DialogTitle>
                {SET_DAY_ONE_START_TIME}
            </DialogTitle>
            <DialogContent sx = {{ overflowY: "visible" }}>
                <Box
                    sx = {{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <TimePicker
                        value = {DateTime.fromJSDate( value )}
                        onChange = {( dateValue: DateTime | null | undefined ) =>
                        {
                            formParent.clearErrors( "startDate" ); // reset any errors if you update the waypoint time
                            if ( dateValue !== null && dateValue !== undefined )
                            {
                                setValue( dateValue.toJSDate() );
                            }
                        }}
                    />
                </Box>
                <Box
                    sx = {{
                        display: "flex",
                        gap: "16px",
                        paddingTop: "16px",
                    }}
                >
                    <Button
                        onClick = {saveAndClose}
                        variant = "contained"
                        sx = {{
                            flex: 1,
                            height: "48px",
                        }}
                    >
                        SAVE
                    </Button>
                    <Button
                        onClick = {handleClose}
                        variant = "outlined"
                        sx = {{
                            flex: 1,
                            height: "48px",
                        }}
                    >
                        {DELETE_CONFIRMATION_NO}
                    </Button>
                </Box>
                <Box sx = {{ display: "flex", paddingTop: "8px" }}>
                    <Button
                        onClick = {deleteStartTime}
                        color = "error"
                        variant = "contained"
                        sx = {{ flex: 1 }}
                    >
                        {DELETE}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
